<template>
	<div class="wrapper list">
		<div class="content">
			<div class="topbar">
				<div class="logo">
					<router-link to="/profile">
						<img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" class="logo" />
					</router-link>
				</div>
				<!-- <div class="info">
					<router-link to="/notifications" class="notifications">
						<div class="icon">
							<div v-if="notificationsUnread" class="counter">{{ notificationsUnread }}</div>
						</div>
					</router-link>
					<div class="profile">
						<img :src="getAvatarById(selectedAvatar)?.image || getAvatarById('1')?.image" :alt="getAvatarById(selectedAvatar)?.name  || getAvatarById('1')?.name" class="currentAvatar" />
					</div>
				</div> -->
			</div>
			<h2>{{ t('txt_events') }}</h2>
			<div v-if="loading" class="skeleton-container">
				<div class="skeleton-message" v-for="n in 3" :key="n">
					<div class="skeleton-padding">
						<!-- <div class="skeleton-title animate__animated animate__pulse animate__infinite"></div> -->
						<div class="skeleton-content animate__animated animate__pulse animate__infinite"></div>
					</div>
				</div>
			</div>
			<div v-else class="events-list">
				<router-link :to="{ path: `/point/${message.id}` }" v-for="message in data.events" :key="message.id" class="message">
					<div class="padding">
						<div class="info">
							<h2 v-html="message.title"></h2>
							<p v-if="isSameDate(message.event_date, message.event_date_end)">{{ formatDate(message.event_date) }}</p>
							<p v-else>{{ formatDate(message.event_date, 'L') }} - {{ formatDate(message.event_date_end, 'L') }}</p>
						</div>
						<div class="sparks" :class="{ done: message.done }">
							<div v-if="message.done == 1" class="done">{{ message.sparks }}</div>
							<div v-else><div class="sparkholder">{{ message.sparks }}</div></div>
						</div>
					</div>
				</router-link>
			</div>
			<h2>{{ t('txt_bulevar_challenge') }}</h2>
			<div v-if="loading" class="skeleton-container">
				<div class="skeleton-message" v-for="n in 3" :key="n">
					<div class="skeleton-padding">
						<!-- <div class="skeleton-title animate__animated animate__pulse animate__infinite"></div> -->
						<div class="skeleton-content animate__animated animate__pulse animate__infinite"></div>
					</div>
				</div>
			</div>
			<div v-else class="points-list">
				<router-link :to="{ path: `/point/${message.id}` }" v-for="message in data.points" :key="message.id" :title="message.title" class="message">
					<div class="padding"  v-if="message.challenge == 'challenge'">
						<div class="info">
							<h2 v-html="message.title"></h2>
						</div>
						<div class="sparks" :class="{ done: message.done }">
							<div v-if="message.done == 1" class="done">{{ message.sparks }}</div>
							<div v-else><div class="sparkholder">{{ message.sparks }}</div></div>
						</div>
					</div>
				</router-link>
			</div>
			<h2>{{ t('txt_bulevar_points') }}</h2>
			<div v-if="loading" class="skeleton-container">
				<div class="skeleton-message" v-for="n in 3" :key="n">
					<div class="skeleton-padding">
						<!-- <div class="skeleton-title animate__animated animate__pulse animate__infinite"></div> -->
						<div class="skeleton-content animate__animated animate__pulse animate__infinite"></div>
					</div>
				</div>
			</div>
			<div v-else class="points-list">
				<router-link :to="{ path: `/point/${message.id}` }" v-for="message in data.points" :key="message.id" :title="message.title" class="message">
					<div class="padding"  v-if="message.challenge == 'location' || message.challenge == 'qr'">
						<div class="info">
							<h2 v-html="message.title"></h2>
						</div>
						<div class="sparks" :class="{ done: message.done }">
							<div v-if="message.done == 1" class="done">{{ message.sparks }}</div>
							<div v-else><div class="sparkholder">{{ message.sparks }}</div></div>
						</div>
					</div>
				</router-link>
			</div>
		</div>
	</div>
	<MobileNav :selected="selectedId" />
</template>

<script>
import { keycloak } from '../keycloak';
import { useI18n } from 'vue-i18n';
import apiClient from '@/utils/axios';
import dayjs from '@/utils/dayjs';
import router from '@/router';

export default {
	props: ['id'],
	name: 'ListPage',
	data() {
		return {
			loading: true,
			selectedId: 2,
			data: [],
			selectedAvatar: this.selectedAvatar,
			subscriptionStatus: false,
			avatars: [
				{ id: '1', image: require('../assets/img/eda-spomenik.svg'), name: 'fox' },
				{ id: '2', image: require('../assets/img/goriska-vrtnica.svg'), name: 'goriska-vrtnica' },
				{ id: '3', image: require('../assets/img/goriski-grad.svg'), name: 'goriski-grad' },
				{ id: '4', image: require('../assets/img/soca.svg'), name: 'soca' },
				{ id: '5', image: require('../assets/img/solkanski-most.svg'), name: 'solkanski-most' },
				{ id: '6', image: require('../assets/img/solkanski-radic.svg'), name: 'solkanski-radic' },
				{ id: '7', image: require('../assets/img/soska-postrv.svg'), name: 'postrv' },
				
			],
			notificationsUnread: 0,
		};
	},
	computed: {
		fullName() {
			return `${keycloak.tokenParsed?.given_name || 'Name'} ${keycloak.tokenParsed?.family_name || 'Surname'}`;
		},
		avatarImage() {
			return this.getAvatarById(this.selectedAvatar)?.image || this.getAvatarById('1')?.image;
		},
		avatarName() {
			return this.getAvatarById(this.selectedAvatar)?.name || this.getAvatarById('1')?.name;
		}
	},
	methods: {
		isSameDate(date1, date2) {
			return (date1 == date2 || date2 == '') ? true : false;
		},
		getAvatarById(id) {
			return this.avatars.find(avatar => avatar.id === id);
		},
		formatDate(date, format = 'L LT') {
			return dayjs(date).locale(localStorage.getItem('lang')).format(format);
		},
	},
	setup() {
		const { t } = useI18n();
		return {
			t
		};
	},
	mounted() {
		this.isAuthenticated = keycloak.authenticated;
		if (this.isAuthenticated) {
			if(!localStorage.getItem('lang')){
				router.push('/');
			}
			this.loading = true;
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition((position) => {
						const { latitude, longitude } = position.coords;
						const query = `?lat=${latitude}&lon=${longitude}`;
						apiClient.get('/' + localStorage.getItem('lang') + '/api/points' + query)
						.then(response => {
							this.data = response.data;
							this.loading = false;
							this.notificationsUnread = response.data.notificationsUnread;
						})
						.catch(apiError => {
							console.log(apiError);
							this.loading = false;
						});
					},
					() => {
						apiClient.get('/' + localStorage.getItem('lang') + '/api/points')
						.then(response => {
							this.data = response.data;
							this.loading = false;
							this.notificationsUnread = response.data.notificationsUnread;
						})
						.catch(apiError => {
							console.log(apiError);
							this.loading = false;
						});
					},
					{ enableHighAccuracy: false, timeout: 5000, maximumAge: 60000 }
				);
			} else {
				apiClient.get('/' + localStorage.getItem('lang') + '/api/points')
					.then(response => {
						this.data = response.data;
						this.loading = false;
						this.notificationsUnread = response.data.notificationsUnread;
					})
					.catch(apiError => {
						console.log(apiError);
						this.loading = false;
					});
			}
		} else {
			this.$router.push('/login');
		}
	}
};
</script>

<style lang="sass" scoped>

</style>